module.exports = __webpack_public_path__ + "static/media/exception.2692c05a.png";